export const environment = {
  name: 'production',
  production: true,
    auth: {
    url:
      'https://mb-bravos-coin-admin-users-production.auth.us-east-1.amazoncognito.com',
    callbackUrl: 'https://bravos.admin.montebravocrm.com/auth',
    region: 'us-east-1',
    userPoolId: '',
    userPoolWebClientId: '',
  },
  apiUrl: 'https://bravos.admin.montebravocrm.com',
  firebase: {
      apiKey: 'AIzaSyDqCBS9QIePfr8SnFYkngzH5Hfmb_pvPH0',
      projectId: 'mb-ir-pgbl',
      appId: '1:787269122940:web:229145ae0d836f307542f9',
      databaseURL: 'https://mb-ir-pgbl-default-rtdb.firebaseio.com',
  },
  features: {
    /** Use here to define feature toggles */
  },
}
